module.exports = __webpack_public_path__ + "videos/launch-en.8a24e37.mp4";